import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, InputNumber, Switch, Button, message, Row, Col } from 'antd';
import axios from 'axios';
import { addPrintSettings, getPrintSettings } from '../../services/doctor/print_settings/printSettings';
import PropTypes from 'prop-types';

const BillSettingModal = ({ visible, onClose, doctorId }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  // Fetch data when modal opens
  useEffect(() => {
    if (visible && doctorId) {
      fetchSettings();
    } else {
      form.resetFields();
    }
  }, [visible, doctorId]);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      // Replace with your actual GET endpoint
      const response = await getPrintSettings(doctorId);
      const data = response.data;

      // Map API data to Form fields
      form.setFieldsValue({
        ...data,
        bill_is_show_signature: data.bill_is_show_signature === 1,
        bill_is_show_at_reception: data.bill_is_show_at_reception === 1,
      });
    } catch (error) {
      message.error("Failed to load invoice settings");
    } finally {
      setLoading(false);
    }
  };

  const handleFinish = async (values) => {
    setConfirmLoading(true);
    try {
      // Format data back to numbers/booleans for API
      const payload = {
        ...values,
        bill_is_show_signature: values.bill_is_show_signature ? 1 : 0,
        bill_is_show_at_reception: values.bill_is_show_at_reception ? 1 : 0,
      };

      const result = await addPrintSettings(payload, doctorId);
      message.success("Settings updated successfully");
      onClose(); // Close modal on success
    } catch (error) {
      message.error("Failed to update settings");
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <Modal
      title="Edit Invoice Template"
      open={visible}
      onCancel={onClose}
      confirmLoading={confirmLoading}
      onOk={() => form.submit()}
      okText="Save"
      width={600}
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={handleFinish}
        initialValues={{ bill_is_show_signature: false }}
        style={{ marginTop: 20 }}
      >
        <Form.Item label="Bill No. Sequence">
          <Row gutter={8}>
            <Col span={10}>
              <Form.Item name="bill_no_sequence_prefix" noStyle>
                <Input placeholder="Prefix (e.g. SRH)" />
              </Form.Item>
            </Col>
            <Col span={14}>
              <Form.Item name="bill_no_sequence_start" noStyle>
                <InputNumber style={{ width: '100%' }} placeholder="Start No." />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item label="Receipt No." name="bill_receipt_no_start">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="GSTIN Number" name="bill_gstin_number">
          <Input placeholder="GSTIN" />
        </Form.Item>

        <Form.Item label="Clinic Name" name="bill_clinic_name">
          <Input />
        </Form.Item>

        <Form.Item label="Clinic Contact" name="bill_clinic_contact">
          <Input />
        </Form.Item>

        <Form.Item label="Clinic Address" name="bill_clinic_address">
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item label="Default Note" name="bill_default_note">
          <Input.TextArea rows={3} placeholder="Type a note..." />
        </Form.Item>

        <Form.Item label="Signature" name="bill_is_show_signature" valuePropName="checked">
          <Switch />
        </Form.Item>
        
        <Form.Item label="Show at Reception" name="bill_is_show_at_reception" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BillSettingModal;

BillSettingModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    doctorId: PropTypes.string.isRequired
};